import React from 'react';

import Table from '@components/Base/Table';
import { CustomColumnDef } from '@components/Base/Table/types';
import { Transactions } from '@containers/transactions/types';

interface TransactionsTableProps {
  transactions: Transactions[];
  columns: CustomColumnDef<Transactions>[];
  transactionsLoading: boolean;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  pageCount: number;
  setPagination: React.Dispatch<React.SetStateAction<{ pageIndex: number; pageSize: number }>>;
}

const TransactionsTable: React.FC<TransactionsTableProps> = (props) => {
  const { transactions, columns, transactionsLoading, pagination, pageCount, setPagination } = props;
  return (
    <div className="h-full">
      <Table<Transactions>
        data={transactions}
        columns={columns}
        isMultiselect={false}
        pagination={pagination}
        pageCount={pageCount}
        setPagination={setPagination}
        isLoading={transactionsLoading}
      />
    </div>
  );
};

export default TransactionsTable;
